import style from './style.module.css';

interface EmptyStateProps {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  error?: boolean;
}

export function EmptyState({ icon, error, title, subtitle }: EmptyStateProps) {
  const classNames = `${style.empty} ${error ? style.error : ''}`;
  return (
    <div className={style.emptyStateContainer}>
      <div className={classNames}>{icon}</div>
      <div className={style.emptyWrapper}>
        <div className={style.title}>{title}</div>
        <div className={style.subtitle}>{subtitle}</div>
      </div>
    </div>
  );
}
